import React from 'react'
import Header from '../_components/common/Header'
import Index from '../_components/Subscription/Index'


const Subscription = () => {
  return (
    <div className='page-main'>
        <Header name = {["Subscription"]} />
        <Index />
    </div>
  )
}

export default Subscription